var rich_content_viewer_default = {
  "fontElementMap": "KYrPy",
  "wrapper": "ZrA2O",
  "pluginContainerMobile": "_8jGQn",
  "viewer": "LaZgk",
  "android": "wXFdQ",
  "rootedTraversedContent": "yTj2F",
  "atomic": "RZx-0",
  "toolbar": "WrTEk",
  "block": "M6jEL"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
